<template>
  <div>
    <OrderPage
      v-if="openOrder || $store.getters.hasPreviousOrdersPaid"
      :order="order"
      :previousOrders="previousOrders"
      @closeOrder="closeOrder"
      @confirmOrder="confirmOrder"
      @removeOrderProduct="removeOrderProduct"
    />
    <!-- Product Selected -->
    <div v-else>
      <selectedProduct
        v-if="selectedProduct"
        app
        :product="selectedProduct"
        @addProduct="addProduct"
        @closeSelectedProduct="closeSelectedProduct"
      />
      <div v-else transition="fade">
        <!-- Barra superior -->
        <appBar
          :categories="filteredMenu.categories"
          :images="images"
          v-model="search"
          :search="search"
        />

        <!-- Lista de productos -->

        <productlist
          class="pt-10"
          style="margin-top:5px"
          :categories="filteredMenu.categories"
          @selectProduct="selectProduct"
          @addProduct="addProduct"
        />
        <!-- Boton de avisar camarero -->
        <waiterButton @callWaiter="callWaiter()" ref="callwaiterbutton" />

        <v-btn
          style="z-index:4"
          v-if="order.products.length"
          app
          color="primary"
          fixed
          bottom
          left
          rounded
          x-large
          @click="showOrder"
        >{{ $t("Add {num} to your Order", { num: order.products.length }) }}</v-btn>
        <div v-else>
          <v-btn
            style="z-index:4"
            v-if="previousOrders.length"
            app
            color="primary"
            fixed
            bottom
            left
            rounded
            x-large
            @click="showOrder"
          >{{ $t("Show order") }}</v-btn>
        </div>
        <v-btn
          style="z-index:4"
          v-if="(order.products.length == 0) & (totalPriceConfirmed > 0)"
          app
          color="primary"
          fixed
          bottom
          left
          rounded
          x-large
          transition="scale-transition"
          @click="showOrder"
        >
          {{
          $t("Pay {price}", { price: localizedPrice(totalPriceConfirmed) })
          }}
        </v-btn>
        <!-- <v-btn
        app
        color="primary"
        fixed
        bottom
        left
        fab
        @click="lastOrdersShow"
        v-if="previousOrders.length"
      >
        <v-icon>mdi-view-headline</v-icon> 
        </v-btn>-->
      </div>
    </div>

    <v-overlay :value="orderVerify" opacity="1" :color="isDark? '#1e1e1e':'white'">
      <v-icon size="200" color="lime">mdi-check</v-icon>
    </v-overlay>
  </div>
</template>

<script>
import appBar from "@/components/AppBar";
import productlist from "@/components/ProductList";
import selectedProduct from "@/components/SelectedProduct";
import waiterButton from "@/components/WaiterButton";
import OrderPage from "@/components/Order";
import { Order, OrderProduct } from "@/model/order";
import Activity from "@/model/activity";

// import Functions from "@/service/functions";

export default {
  name: "App",
  components: { appBar, productlist, waiterButton, selectedProduct, OrderPage },
  props: ["newUser"],
  data() {
    return {
      orderVerify: false,
      search: "",
      user: null,
      shake: false,
      selectedProduct: null,
      openOrder: false,
      // TODO Mock data
      order: new Order({ products: [] }), // TODO Delete when reading from Firebase
      savedScroll: null
    };
  },

  created() {
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }
    this.$vuetify.theme.themes.light.primary = this.colors.light;
    this.$vuetify.theme.themes.light.accent = this.colors.light;
    this.$vuetify.theme.themes.dark.primary = this.colors.dark;
    this.$vuetify.theme.themes.dark.accent = this.colors.dark;
    this.order = this.$store.state["thisOrder" + this.$store.state.restaurantId]
      ? new Order(
          this.$store.state["thisOrder" + this.$store.state.restaurantId]
        )
      : new Order({ products: [] });
  },

  computed: {
    isDark() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    },
    filteredMenu() {
      return this.$store.getters.menu.filter(this.search);
    },

    menu() {
      let menu = this.$store.getters.menu;
      return menu;
    },

    colors() {
      return this.$store.getters.menu.colors;
    },

    images() {
      return this.$store.getters.menu;
    },
    previousOrders() {
      let orders = [];
      this.$store.state._orders.forEach(order => {
        orders.push(Order.fromMap(order));
      });
      return orders;
    },
    // TODO order() {
    //   return this.order; // getCurrent(store.getters.customer.orders);
    // },

    // TODO Get relevant previousOrders (unpaid, this establishment )
    // previousOrders() {
    //   return // dataManager.previousOrders;
    // },

    totalPriceConfirmed() {
      // let total = 0;
      // for (let order in dataManager.previousOrders) {
      //   for (let product in dataManager.previousOrders[order]) {
      //     total =
      //       total + parseFloat(dataManager.previousOrders[order][product].price);
      //   }
      // }
      // TODO Think about this
      return this.order.totalPrice;
    }
  },

  filters: {
    // Filter definitions

    currency(value) {
      return parseFloat(value).toFixed(2) + " €";
    }
  },

  methods: {
    localizedPrice(price) {
      return parseFloat(price).toFixed(2) + " €";
    },

    showOrder() {
      this.openOrder = true;
    },

    closeOrder() {
      this.openOrder = false;
      this.justPopped();
    },

    async confirmOrder() {
      this.order.session = this.$store.state.session;
      this.order.date = new Date();
      this.order.notifyToken = this.$store.getters.notifyToken;
      this.order.save();

      this.$gtag.event("new_order", {
        location: this.$store.state.location,
        locationName: this.$store.state._locationObject.name,
        price: this.order.price,
        restaurantId: this.$store.state.restaurantId
      });
      this.verifyImage();
      let activity = Activity.fromMap({
        location: this.$store.state.location,
        type: "newOrder",
        date: new Date()
      });
      activity.save();
      this.order = new Order({ products: [] });
      this.updateStoreOrder();
    },
    verifyImage() {
      console.log("animation");
      this.orderVerify = true;
      let that = this;
      setTimeout(function() {
        that.orderVerify = false;
      }, 1000);
    },
    goto: function(id) {
      document.getElementById(id).scrollIntoView(true);
      window.scrollBy(0, -90);
      if (
        window.pageYOffset >=
        document.body.offsetHeight - window.innerHeight - 40
      ) {
        document.getElementById(id).scrollIntoView(true);
      }
    },

    saveScrollPosition() {
      this.savedScroll = { x: window.scrollX, y: window.scrollY };
    },

    selectProduct(product) {
      this.selectedProduct = product;
      this.saveScrollPosition();
    },

    addProduct(product) {
      // TODO Fix out of data manager
      // dataManager.addProduct(this.selectedProduct);
      let orderProductMap = {
        ...product,

        comment: product.comment ? product.comment : "",
        status: "pending"
      };
      let orderProduct = OrderProduct.fromMap(orderProductMap);
      this.order.products.push(orderProduct);
      this.updateStoreOrder();
    },

    closeSelectedProduct() {
      this.selectedProduct = null;
      this.justPopped();
    },

    callWaiter() {
      this.waiter = false;
      // TODO Fix out of data manager
      // dataManager.callWaiter();
      this.$refs.callwaiterbutton.shake = true;
    },

    justPopped() {
      if (this.savedScroll) {
        this.$vuetify.goTo(this.savedScroll.y, { duration: 0 });
        this.savedScroll = null;
      }
    },

    removeOrderProduct(productIndex) {
      let i = 0;
      this.order.products = this.order.products.filter(
        () => productIndex !== i++
      );
      this.updateStoreOrder();
    },

    updateStoreOrder() {
      this.$store.commit("set", {
        varName: "thisOrder" + this.$store.state.restaurantId,
        value: this.order
      });
    }
  }
};
</script>
<style>
.v-slide-group__prev {
  display: none !important;
}
</style>
